var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0115 9.91475L12.8615 2.12975C12.6575 1.95675 12.3585 1.95675 12.1545 2.12975L2.9745 9.94875C2.7455 10.1438 2.7175 10.4878 2.9125 10.7168C3.0205 10.8438 3.1735 10.9087 3.3275 10.9087C3.4525 10.9087 3.5785 10.8658 3.6805 10.7788L3.7525 10.7168V20.4827C3.7525 20.7838 3.9965 21.0278 4.2975 21.0278H20.6535C20.9545 21.0278 21.1985 20.7838 21.1985 20.4827V10.6547L21.3055 10.7458C21.5345 10.9408 21.8785 10.9128 22.0735 10.6838C22.2685 10.4538 22.2405 10.1097 22.0115 9.91475ZM14.6565 19.9037H10.2955V13.5437H14.6565V19.9037ZM15.7475 19.9377H20.1085V9.72675L12.5085 3.26075L4.8445 9.78875V19.9377H9.2055V12.9987C9.2055 12.6978 9.4495 12.4537 9.7505 12.4537H15.2025C15.5035 12.4537 15.7475 12.6978 15.7475 12.9987V19.9377Z",
    fill: "#1253FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.266bdb9e.svg";
export { ForwardRef as ReactComponent };